<template>
    <div class="body">
      <div class="header">
        <el-form :model="RetouchingFileFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="文件名称">
              <el-input
                v-model="RetouchingFileFindDTO.name"
                placeholder="订单名称"
              ></el-input>
            </el-form-item>
          <el-form-item label="下载状态">
          <el-select clearable v-model="RetouchingFileFindDTO.downloadStatus" style="width:200px">
            <el-option
              v-for="item in downloadStatus"
              clearable
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="确认状态">
          <el-select clearable v-model="RetouchingFileFindDTO.confirmStatus" style="width:200px">
            <el-option
              v-for="item in confirmStatus"
              clearable
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="修图状态">
          <el-select clearable v-model="RetouchingFileFindDTO.retouchingStatus" style="width:200px">
            <el-option
              v-for="item in retouchingStatus"
              clearable
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-button class="btn-style btn-search" type="success" @click="serchInfo">搜索</el-button>
          <el-form-item>
            <el-button class="btn-style btn-download" @click="submit" type="primary">下载</el-button>
            <el-button class="btn-style btn-confirm" @click="confirmConfirmStatus" type="primary">确认</el-button>
            <el-button class="btn-style btn-cancel" @click="updateConfirmStatus" type="warning">取消确认</el-button>
            <el-button class="btn-style btn-redownload" @click="updateDownloadStatus" type="warning">重新下载</el-button>
            <el-button class="btn-style btn-redownload" @click="updateCollage" type="warning">推送修图</el-button>
            <el-button class="btn-style btn-redownload" @click="updateToArtificial" type="warning">等待人工确认</el-button>
            <el-button class="btn-style btn-delete" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
          <br>
          <el-form-item>
           产品: <el-button size="small" type="warning" v-for="item in AllRetouchingFileSet" :key="item" @click="find1(item)">
                {{ item }}
         </el-button>
          </el-form-item>
          <br>

        </el-form>
        <el-dialog title="编辑修图文件" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false" class="order-dialog">
        <el-form
          ref="accountForm"
          :rules="rules"
          
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm form-style"
        >
          <el-form-item label="产品" prop="largeCategory">
            <el-select clearable v-model="accountForm.largeCategory" style="width:200px" allow-create  filterable @blur.native.capture="largeCategorySelect" @change="selectAllSubclass">
            <el-option
              v-for="item in largeCategory"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
          <el-form-item label="材料">
            <el-select clearable v-model="accountForm.subclass" style="width:200px" allow-create filterable @blur.native.capture="subclassSelect" @change="subclassSelect" >
            <el-option
              v-for="item in subclass"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
            </el-form-item>
            <el-form-item label="名称">
              <el-input
                v-model="accountForm.name"
                placeholder="名称"
              ></el-input>
            </el-form-item>
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </el-form>
      </el-dialog>
        <div style="display: flex">

          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
   
      <div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :header-cell-style="{borderColor:'#C0C0C0'}"
          :cell-style="{borderColor:'#C0C0C0'}"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="上传时间"
          ></el-table-column>
        <el-table-column
    prop="thumbnail"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="文件名称"
          ></el-table-column>

          <el-table-column
            prop="largeCategory"
            align="center"
            label="产品"
          ></el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="材料工艺"
          ></el-table-column>
          <!-- <el-table-column
            prop="customerName"
            align="center"
            label="客户名称"
          ></el-table-column> -->
          <el-table-column
            prop="materialEvaluation"
            align="center"
            label="用料评估"
          ></el-table-column>
          <el-table-column
            prop="fileSize"
            align="center"
            label="文件大小\单位:M"
          ></el-table-column>
          <el-table-column
            prop="reviewer"
            align="center"
            label="审核人"
          ></el-table-column>
          <!-- <el-table-column
            prop="downloadStatus"
            align="center"
            label="下载状态"
          >     <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.downloadStatus==='0'">未下载</el-tag>
            <el-tag type="success" v-if="scope.row.downloadStatus==='1'">已下载</el-tag>
        </template>
        </el-table-column>
          <el-table-column
            prop="confirmStatus"
            align="center"
            label="确认状态"
          >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.confirmStatus==='0'">未确认</el-tag>
            <el-tag type="success" v-if="scope.row.confirmStatus==='1'">已确认</el-tag>
        </template></el-table-column> -->

        <el-table-column
            prop="retouchingStatus"
            align="center"
            label="修图状态"
          >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.retouchingStatus==='0'">待修图</el-tag>
            <el-tag type="success" v-if="scope.row.retouchingStatus==='1'">已修图</el-tag>
            <el-tag type="success" v-if="scope.row.retouchingStatus==='2'">修图中</el-tag>
            <el-tag type="danger" v-if="scope.row.retouchingStatus==='3'">问题文件</el-tag>
            <el-tag type="info" v-if="scope.row.retouchingStatus==='4'">人工修图</el-tag>
            <el-tag type="danger" v-if="scope.row.retouchingStatus==='5'">加急</el-tag>
        </template></el-table-column>
        <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </template>

  <script>
  const OSS = require('ali-oss');
  import JSZip from 'jszip'
  import FileSaver from 'file-saver'
  import {selectRetouchingFile,retouchingFileSettings,upDateRetouchingFile,getLargeCategory,updateDownloadStatus,updateConfirmStatus,retouchingFileBatchDelete,confirmConfirmStatus,updateCollage,updateToArtificial,updateCollageUrgent,selectAllLargeCategory,selectAllSubclass} from '@/api/file/retouchingFile.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        allSubclass:[],
        confirmStatus:[{
          value: '0',
          label: '未确认'
        }, {
          value: '1',
          label: '已确认'
        }],
        downloadStatus: [{
          value: '0',
          label: '未下载'
        }, {
          value: '1',
          label: '已下载'
        }],
        retouchingStatus:[{
          value: '0',
          label: '未修图'
        },{
          value: '1',
          label: '已修图'
        },{
          value: '2',
          label: '正在修图'
        },{
          value: '3',
          label: '修图失败'
        },{
          value: '4',
          label: '人工修图'
        }],
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        dialogVisible:false,
        AllRetouchingFileSet:'',
        date: '',
        conTract: [],
        RetouchingFileFindDTO:{
            name:'',
            startTime: '',
            endTime: '',
            largeCategory: '',
            subclass:'',
            access:'',
            confirmStatus:'',
            retouchingStatus:'',
            downloadStatus:'',
        },
        drawer: false,
        largeCategory:[],
        subclass:[],
        accountForm:{
          id:'',
          access:'',
          deliveryMethod:'',
          deliveryTime:'', 
          largeCategory: '',
            subclass:'',
          customerName:'',
          contacts:'',
          thumbnail:'',
          confirmStatus:'',
          downloadStatus:'',
          address:'',
          retouchingStatus:'',
          fileSize:'',
          customerName:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
            // deliveryMethod:[
            //         { required: true, message: '请输入发货方式', trigger: 'blur' }]
            },
            client: new OSS({
                // 你的Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: 'oss-cn-huhehaote',
                // 你的accessKeyId 和 accessKeySecret
                // 官方建议：阿里云账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM用户进行API访问或日常运维，请登录RAM控制台创建RAM用户。
                accessKeyId: 'LTAI5t7oe29RgGbGLzb5UE5X',
                accessKeySecret: 'oFp52wXNyHG9YW7opk3uMo1rgbYzYD',
                // 你的Bucket名称。
                bucket: 'service-center-liuchi'
            })


      }
    },
    created(){
      // const start = new Date()
      //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
      //   this.OrderDeliveryFindDTO.startTime= start
      //   const end = new Date()
      //   end.setTime(end.getTime() - 3600 * 1000 * 24 * 2)
      //   this.OrderDeliveryFindDTO.endTime= end


    },
    mounted() {
      this.RetouchingFileFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 *2)
        this.RetouchingFileFindDTO.startTime= start
        const end = new Date()
        this.RetouchingFileFindDTO.endTime= end
        this.date=[start,this.RetouchingFileFindDTO.endTime]
      this.getAllRetouchingFileSet()
      this.selectAllLargeCategory()
      // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      selectAllLargeCategory(){
        selectAllLargeCategory(localStorage.getItem("access")).then((res) => {
        if(res.data.msg === '操作成功'){
            this.largeCategory=res.data.data;
        }
      })
      },
        selectAllSubclass(){
          selectAllSubclass(this.accountForm).then((res) => {
        if(res.data.msg === '操作成功'){
            this.subclass=res.data.data;
        }
      })
      },
      largeCategorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.largeCategory = e.target.value
            }
        },
      subclassSelect(e) {
                if(e.target.value) { 
                    this.accountForm.subclass = e.target.value
            }
        },
    
      //修改
   editAccount() {
    console.log(this.accountForm)
    upDateRetouchingFile(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getAllRetouchingFileSet()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      find(data){
        this.RetouchingFileFindDTO.subclass=data
       this.getTable();
    },
    async   find1(data){
      this.RetouchingFileFindDTO.largeCategory=data
       this.getTable();
    },
    async   getAllRetouchingFileSet(){
      await   getLargeCategory(this.RetouchingFileFindDTO).then((res) => {
        if(res.data.msg === '操作成功'){
            this.AllRetouchingFileSet=res.data.data;
            this.RetouchingFileFindDTO.largeCategory=res.data.data[0];
        }
        this.getTable()

        })

    },
    updateDownloadStatus(){
      updateDownloadStatus(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.msg === '操作成功'){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '返回未未下载状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    confirmConfirmStatus(){
      confirmConfirmStatus(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.msg === '操作成功'){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '返回为未确认状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateConfirmStatus(){
      updateConfirmStatus(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.msg === '操作成功'){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '返回为未确认状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateCollage(){
      updateCollage(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.msg === '操作成功'){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '推送修图成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateToArtificial(){
      updateToArtificial(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.msg === '操作成功'){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '设为人工修图状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateCollageUrgent(){
      updateCollageUrgent(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.msg === '操作成功'){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '设为人工修图状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
   

    // async   submit() {
    //     let file_name= this.multipleSelection[0].path;
    //        if(this.multipleSelection.length==0){
    //         this.$message({
    //           type: "error",
    //           message: "sorry,你还没有勾选任何文件呢!"
    //         });
    //         return;
    //       }
    //         if(this.multipleSelection.length>1){
    //         this.$message({
    //           type: "error",
    //           message: "sorry,目前只支持单个文件下载!"
    //         });
    //         return;
    //       }
    //         let app = this;
    //         // 下载函数
    //         async function getStream() {
    //             try {
    //               console.log(file_name)
    //                 // 自定义响应头
    //                 // 获取下载文件的签名URL，配置文件HTTP头中的Content-Disposition为attachment，实现浏览器访问时自动下载文件，并自定义下载后的文件名称。
    //                 const response = {
    //                     'content-disposition': `attachment; filename=${encodeURIComponent(file_name)}`
                   
    //                 };
    //                 const url = app.client.signatureUrl(file_name, { response });
    //                 // 新窗口打开URL
    //                 window.open(file_name);
    //             } catch (err) {
    //                 // 全局提示
    //                 this.$message({
    //           type: "error",
    //           message: "sorry,目前只支持单个文件下载!"
    //         });
    //                 控制台答应错误
    //                 console.error(err);
    //             }
    //         }
    //         // 开始下载
    //         getStream();
    //     },
    submit() {
                let temp = this.multipleSelection
                let urls = []
                for (let i = 0; i < temp.length; i++) {
                    let a = {
                        fileUrl: temp[i].path,
                        renameFileName: temp[i].name
                    }
                    urls.push(a)
                }
                console.log(urls)
                this.filesToRar(urls)
            },
            /**文件打包
             * arrImages:文件list:[{fileUrl:文件url,renameFileName:文件名}]
             * filename 压缩包名
             * */
            filesToRar(arrImages) {
                let _this = this;
                let zip = new JSZip();
                let cache = {};
                let promises = [];
                _this.$message.success('正在下载请稍等！！！！');
                for (let item of arrImages) {
                    const promise = _this.getImgArrayBuffer(item.fileUrl).then(data => {
                        // 下载文件, 并存成ArrayBuffer对象(blob)
                        zip.file(item.renameFileName, data, {
                            binary: true
                        }); // 逐个添加文件
                        cache[item.renameFileName] = data;
                    });
                    promises.push(promise);
                }

                Promise.all(promises).then(() => {
                    zip.generateAsync({
                        type: "blob"
                    }).then(content => {
                        // 生成二进制流
                        FileSaver.saveAs(content, this.getCurrentTime()); // 利用file-saver保存文件  自定义文件名
                        _this.$message.success('压缩完成');
                    });
                }).catch(res => {
                    _this.$message.success('压缩失败');
                });
            },
            //获取文件blob
            getImgArrayBuffer(url) {
                let _this = this;
                return new Promise((resolve, reject) => {
                    //通过请求获取文件blob格式
                    let xmlhttp = new XMLHttpRequest();
                    xmlhttp.open("GET", url, true);
                    xmlhttp.responseType = "blob";
                    xmlhttp.onload = function() {
                        if (this.status == 200) {
                            resolve(this.response);
                        } else {
                            reject(this.status);
                        }
                    }
                    xmlhttp.send();
                });

            },

    getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
    console.log(_this.gettime)
    return _this.gettime;
    },


      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTable()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTable()
      },

      getTable(){
        selectRetouchingFile(this.currentPage, this.pageSize, this.RetouchingFileFindDTO).then((res) => {
            //console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
   //修改

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.msg === '操作成功'){
              this.getTable()
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          retouchingFileBatchDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.RetouchingFileFindDTO.startTime = e[0]
          this.RetouchingFileFindDTO.endTime = e[1]
        } else if (!e) {
          this.RetouchingFileFindDTO.startTime = ''
          this.RetouchingFileFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getAllRetouchingFileSet()
      },

    }
  }
  </script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
}

.body {
    overflow: auto;
}

.pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
}

.el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.goodsTableData{
    margin: 20px 0 ;
}
.btn-style{
    min-width: 72px;
    border-radius: 8px;
}
.btn-search{
    background: var(--theme-color);
}
.btn-buy{
    background: #FF8429;
}
.btn-print{
    background: #4093FF;
}
.btn-delete{
    background: #FF4D4D;
}
.btn-view{
    background: var(--theme-color);
}
.product-form .el-form-item{
    margin-bottom: 0;
}
.table-content{
    margin: 20px;
}
.check-all{
    color: #333;
    font-size: 16px;
    margin-right: 20px;
    cursor: pointer;
}
.el-pagination{
    margin: 0;
}

.el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
    border-radius: 8px;
}

.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.table-image{
    width: 100px;
    height: 50px;
    margin-right: 20px;
}
::v-deep.table-image .image-slot{
    height: 50px;
    display: flex;
    align-items: center;
}
::v-deep.table-image .image-slot i{
    font-size: 50px;
}
.pay{
    color:var(--theme-color);
}
.no-pay{
    color:#FF4D4D;
}
.btn-group{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.btn-group .el-button{
    border-radius: 20px;
    width: 76px;
}
.btn-collection{
    background: #F9DDDD;
}
.btn-view-detail{
    background: #D3F2E4;
    color: var(--theme-color);
}
.btn-reckon{
    background: rgb(245, 233, 212);
  
}

::v-deep.order-dialog .el-dialog{
    border-radius: 24px;
}
.operator label{
    letter-spacing: 5px;
}
::v-deep.dialog-upload{
    display: flex;
}
::v-deep.dialog-upload .el-form-item__label{
    flex-shrink: 0;
}
::v-deep.dialog-upload .el-form-item__content{
    justify-content: right;
}
::v-deep.dialog-upload .avatar-uploader{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #D8E0DD;
}
::v-deep.dialog-upload .el-upload--text{
    width: 100%;
    height: 100%;
}
::v-deep.dialog-upload img{
    max-width: 100px;
}
.accountForm-header{
    background: #F7F7F7;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px;
}
.btn-add{
    background: #FF8429;
    border-radius: 8px;
}
.form-submit{
    background: var(--theme-color);
    border-radius: 8px;
}
::v-deep.el-table thead th{
    background: #EAF4F0;
    color: var(--secondColor);
}
.table-no-pay{
    background: #ffeded;
}

::v-deep.el-icon-remove-outline{
    font-size: 32px;
    color: #a3d8f9cc;
}
</style>